/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchNotificationOperation,
    BatchNotificationOperationFromJSON,
    BatchNotificationOperationToJSON,
    CustomerMarketingSubscribeParams,
    CustomerMarketingSubscribeParamsFromJSON,
    CustomerMarketingSubscribeParamsToJSON,
    CustomerMarketingUnsubscribeParams,
    CustomerMarketingUnsubscribeParamsFromJSON,
    CustomerMarketingUnsubscribeParamsToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    Notification,
    NotificationFromJSON,
    NotificationToJSON,
    NotificationList,
    NotificationListFromJSON,
    NotificationListToJSON,
    NotificationPreferences,
    NotificationPreferencesFromJSON,
    NotificationPreferencesToJSON,
    NotificationTopicGroup,
    NotificationTopicGroupFromJSON,
    NotificationTopicGroupToJSON,
    PushSubscription,
    PushSubscriptionFromJSON,
    PushSubscriptionToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    WebPushPreload,
    WebPushPreloadFromJSON,
    WebPushPreloadToJSON,
} from '../models';

export interface ArchiveAllNotificationRequest {
    program_id: string;
}

export interface ArchiveNotificationRequest {
    program_id: string;
    notification_id: string;
}

export interface FindNotificationPreferencessRequest {
    topic_group?: Array<NotificationTopicGroup>;
}

export interface FindNotificationsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
    topic_group?: Array<NotificationTopicGroup>;
    is_archived?: boolean;
    is_read?: boolean;
}

export interface FindOneNotificationRequest {
    program_id: string;
    id: string;
}

export interface GetPreloadWebPushRequest {
    X_CSRF_TOKEN?: string;
}

export interface MarkAllAsReadNotificationRequest {
    program_id: string;
}

export interface MarkAsReadNotificationRequest {
    program_id: string;
    notification_id: string;
}

export interface MarkAsUnreadNotificationRequest {
    program_id: string;
    notification_id: string;
}

export interface SubscribeCustomerMarketingRequest {
    CustomerMarketingSubscribeParams: CustomerMarketingSubscribeParams;
}

export interface SubscribeWebPushRequest {
    PushSubscription: PushSubscription;
    X_CSRF_TOKEN?: string;
}

export interface TestWebPushRequest {
    X_CSRF_TOKEN?: string;
}

export interface UnarchiveNotificationRequest {
    program_id: string;
    notification_id: string;
}

export interface UnsubscribeAllWebPushRequest {
    X_CSRF_TOKEN?: string;
}

export interface UnsubscribeCustomerMarketingRequest {
    CustomerMarketingUnsubscribeParams: CustomerMarketingUnsubscribeParams;
}

export interface UnsubscribeWebPushRequest {
    endpoint: string;
    X_CSRF_TOKEN?: string;
}

export interface UpdateNotificationPreferencesRequest {
    NotificationPreferences: NotificationPreferences;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Archive all notifications
     */
    async archiveAllNotificationRaw(requestParameters: ArchiveAllNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchNotificationOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling archiveAllNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/archive_all`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchNotificationOperationFromJSON(jsonValue));
    }

    /**
     * Archive all notifications
     */
    async archiveAllNotification(requestParameters: ArchiveAllNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchNotificationOperation> {
        const response = await this.archiveAllNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Archive notification
     */
    async archiveNotificationRaw(requestParameters: ArchiveNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling archiveNotification.');
        }

        if (requestParameters.notification_id === null || requestParameters.notification_id === undefined) {
            throw new runtime.RequiredError('notification_id','Required parameter requestParameters.notification_id was null or undefined when calling archiveNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/{notification_id}/archive`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters.notification_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Archive notification
     */
    async archiveNotification(requestParameters: ArchiveNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Notification> {
        const response = await this.archiveNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all notification preferences
     */
    async findNotificationPreferencessRaw(requestParameters: FindNotificationPreferencessRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<NotificationPreferences>> {
        const queryParameters: any = {};

        if (requestParameters.topic_group) {
            queryParameters['topic_group'] = requestParameters.topic_group;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/preferences/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationPreferencesFromJSON(jsonValue));
    }

    /**
     * List all notification preferences
     */
    async findNotificationPreferencess(requestParameters: FindNotificationPreferencessRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<NotificationPreferences> {
        const response = await this.findNotificationPreferencessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all Notifications
     */
    async findNotificationsRaw(requestParameters: FindNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<NotificationList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findNotifications.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.topic_group) {
            queryParameters['topic_group'] = requestParameters.topic_group;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_read !== undefined) {
            queryParameters['is_read'] = requestParameters.is_read;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationListFromJSON(jsonValue));
    }

    /**
     * List all Notifications
     */
    async findNotifications(requestParameters: FindNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<NotificationList> {
        const response = await this.findNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find Notification by id
     */
    async findOneNotificationRaw(requestParameters: FindOneNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneNotification.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Find Notification by id
     */
    async findOneNotification(requestParameters: FindOneNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Notification> {
        const response = await this.findOneNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find the web-push public key.
     */
    async getPreloadWebPushRaw(requestParameters: GetPreloadWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<WebPushPreload>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.X_CSRF_TOKEN !== undefined && requestParameters.X_CSRF_TOKEN !== null) {
            headerParameters['X-CSRF-TOKEN'] = String(requestParameters.X_CSRF_TOKEN);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/subscriptions/notifications/preload`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebPushPreloadFromJSON(jsonValue));
    }

    /**
     * Find the web-push public key.
     */
    async getPreloadWebPush(requestParameters: GetPreloadWebPushRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<WebPushPreload> {
        const response = await this.getPreloadWebPushRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark all notifications as read
     */
    async markAllAsReadNotificationRaw(requestParameters: MarkAllAsReadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchNotificationOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markAllAsReadNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/mark_all`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchNotificationOperationFromJSON(jsonValue));
    }

    /**
     * Mark all notifications as read
     */
    async markAllAsReadNotification(requestParameters: MarkAllAsReadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchNotificationOperation> {
        const response = await this.markAllAsReadNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark notification as read
     */
    async markAsReadNotificationRaw(requestParameters: MarkAsReadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markAsReadNotification.');
        }

        if (requestParameters.notification_id === null || requestParameters.notification_id === undefined) {
            throw new runtime.RequiredError('notification_id','Required parameter requestParameters.notification_id was null or undefined when calling markAsReadNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/{notification_id}/mark`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters.notification_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Mark notification as read
     */
    async markAsReadNotification(requestParameters: MarkAsReadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Notification> {
        const response = await this.markAsReadNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark notification as unread
     */
    async markAsUnreadNotificationRaw(requestParameters: MarkAsUnreadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling markAsUnreadNotification.');
        }

        if (requestParameters.notification_id === null || requestParameters.notification_id === undefined) {
            throw new runtime.RequiredError('notification_id','Required parameter requestParameters.notification_id was null or undefined when calling markAsUnreadNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/{notification_id}/unmark`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters.notification_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Mark notification as unread
     */
    async markAsUnreadNotification(requestParameters: MarkAsUnreadNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Notification> {
        const response = await this.markAsUnreadNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to program\'s marketing
     */
    async subscribeCustomerMarketingRaw(requestParameters: SubscribeCustomerMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.CustomerMarketingSubscribeParams === null || requestParameters.CustomerMarketingSubscribeParams === undefined) {
            throw new runtime.RequiredError('CustomerMarketingSubscribeParams','Required parameter requestParameters.CustomerMarketingSubscribeParams was null or undefined when calling subscribeCustomerMarketing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/notifications/subscribe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerMarketingSubscribeParamsToJSON(requestParameters.CustomerMarketingSubscribeParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Subscribe to program\'s marketing
     */
    async subscribeCustomerMarketing(requestParameters: SubscribeCustomerMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.subscribeCustomerMarketingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to push notifications.
     */
    async subscribeWebPushRaw(requestParameters: SubscribeWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.PushSubscription === null || requestParameters.PushSubscription === undefined) {
            throw new runtime.RequiredError('PushSubscription','Required parameter requestParameters.PushSubscription was null or undefined when calling subscribeWebPush.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.X_CSRF_TOKEN !== undefined && requestParameters.X_CSRF_TOKEN !== null) {
            headerParameters['X-CSRF-TOKEN'] = String(requestParameters.X_CSRF_TOKEN);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/subscriptions/notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PushSubscriptionToJSON(requestParameters.PushSubscription),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Subscribe to push notifications.
     */
    async subscribeWebPush(requestParameters: SubscribeWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.subscribeWebPushRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test push notifications.
     */
    async testWebPushRaw(requestParameters: TestWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.X_CSRF_TOKEN !== undefined && requestParameters.X_CSRF_TOKEN !== null) {
            headerParameters['X-CSRF-TOKEN'] = String(requestParameters.X_CSRF_TOKEN);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/subscriptions/notifications/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Test push notifications.
     */
    async testWebPush(requestParameters: TestWebPushRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.testWebPushRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unarchive notification
     */
    async unarchiveNotificationRaw(requestParameters: UnarchiveNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unarchiveNotification.');
        }

        if (requestParameters.notification_id === null || requestParameters.notification_id === undefined) {
            throw new runtime.RequiredError('notification_id','Required parameter requestParameters.notification_id was null or undefined when calling unarchiveNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/notifications/{notification_id}/unarchive`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"notification_id"}}`, encodeURIComponent(String(requestParameters.notification_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Unarchive notification
     */
    async unarchiveNotification(requestParameters: UnarchiveNotificationRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Notification> {
        const response = await this.unarchiveNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unsubscribe from all push notifications.
     */
    async unsubscribeAllWebPushRaw(requestParameters: UnsubscribeAllWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.X_CSRF_TOKEN !== undefined && requestParameters.X_CSRF_TOKEN !== null) {
            headerParameters['X-CSRF-TOKEN'] = String(requestParameters.X_CSRF_TOKEN);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/subscriptions/notifications`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Unsubscribe from all push notifications.
     */
    async unsubscribeAllWebPush(requestParameters: UnsubscribeAllWebPushRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.unsubscribeAllWebPushRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to program\'s marketing
     */
    async unsubscribeCustomerMarketingRaw(requestParameters: UnsubscribeCustomerMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.CustomerMarketingUnsubscribeParams === null || requestParameters.CustomerMarketingUnsubscribeParams === undefined) {
            throw new runtime.RequiredError('CustomerMarketingUnsubscribeParams','Required parameter requestParameters.CustomerMarketingUnsubscribeParams was null or undefined when calling unsubscribeCustomerMarketing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/profile/notifications/unsubscribe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerMarketingUnsubscribeParamsToJSON(requestParameters.CustomerMarketingUnsubscribeParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Subscribe to program\'s marketing
     */
    async unsubscribeCustomerMarketing(requestParameters: UnsubscribeCustomerMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.unsubscribeCustomerMarketingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unsubscribe device to push notifications.
     */
    async unsubscribeWebPushRaw(requestParameters: UnsubscribeWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.endpoint === null || requestParameters.endpoint === undefined) {
            throw new runtime.RequiredError('endpoint','Required parameter requestParameters.endpoint was null or undefined when calling unsubscribeWebPush.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.X_CSRF_TOKEN !== undefined && requestParameters.X_CSRF_TOKEN !== null) {
            headerParameters['X-CSRF-TOKEN'] = String(requestParameters.X_CSRF_TOKEN);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/subscriptions/notifications/{endpoint}`.replace(`{${"endpoint"}}`, encodeURIComponent(String(requestParameters.endpoint))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Unsubscribe device to push notifications.
     */
    async unsubscribeWebPush(requestParameters: UnsubscribeWebPushRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.unsubscribeWebPushRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update notification preferences
     */
    async updateNotificationPreferencesRaw(requestParameters: UpdateNotificationPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<NotificationPreferences>> {
        if (requestParameters.NotificationPreferences === null || requestParameters.NotificationPreferences === undefined) {
            throw new runtime.RequiredError('NotificationPreferences','Required parameter requestParameters.NotificationPreferences was null or undefined when calling updateNotificationPreferences.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/preferences/notifications`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferencesToJSON(requestParameters.NotificationPreferences),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationPreferencesFromJSON(jsonValue));
    }

    /**
     * Update notification preferences
     */
    async updateNotificationPreferences(requestParameters: UpdateNotificationPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<NotificationPreferences> {
        const response = await this.updateNotificationPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
